export enum PostClosingTabsEnum {
  TRAILING_DOCUMENTS = 'trailingDocuments',
  SPECIALIST_REASSIGNMENT = 'specialistReassignment',
  COLLATERAL_MANAGEMENT = 'collateralManagement',
}

export const POST_CLOSING_TABS = [
  {
    label: 'Trailing Documents',
    value: PostClosingTabsEnum.TRAILING_DOCUMENTS,
  },
  {
    label: 'Specialist Reassignment',
    value: PostClosingTabsEnum.SPECIALIST_REASSIGNMENT,
  },
  {
    label: 'Collateral Management',
    value: PostClosingTabsEnum.COLLATERAL_MANAGEMENT,
  },
];